import React, {useContext, useEffect, useState} from "react";
import {Grid} from "@mui/material";
import InventoryCorrectionsTable from "../InventoryCorrectionsTable/InventoryCorrectionsTable";
import SubmittedCorrectionsSortFilter from "./SubmittedCorrectionsSortFilter";
import {
  InventoryCorrectionReasonLabel,
  InventoryCorrectionReasons,
  InventoryCorrectionStatus,
} from "../../constants/inventory-correction-constants";
import {getDates} from "../../../views/inventory-correction/util";
import moment from "moment";
import {DateFormats} from "../../constants/securspace-constants";
import InfoCardLoadingSkeleton from "../../skeleton/InfoCardLoadingSkeleton";
import {AppContext} from "../../../context/app-context";
import {ObservableVariables} from '../../constants/observable-constants';
import {BuyerInventoryFilterContainer} from "../../../views/inventory-correction/BuyerInventoryCorrections/styles";

const SubmittedCorrectionsTab = ({
  account,
  loading,
  rawCorrections,
  query,
  setQuery,
  setSort,
  setCorrectionToReview,
  snackbarShowMessage,
  handleOpenReviewModal,
}) => {

  const [formattedCorrections, setFormattedCorrections] = useState([]);
  const appContext = useContext(AppContext);

  const reviewInventoryCorrection = (item) => {
    const rawInventoryCorrection = rawCorrections.find(correction => correction.id === item.item.id);
    setCorrectionToReview(rawInventoryCorrection);
    handleOpenReviewModal();
  };

  const determineEquipmentNumber = (item) => {

    if (item.status === InventoryCorrectionStatus.APPROVED) {
      const {containerNumber, chassisNumber, trailerNumber, truckLicensePlateNumber} = item;

      return containerNumber || chassisNumber || trailerNumber || truckLicensePlateNumber || '';
    } else {
      const {containerNumber, chassisNumber, trailerNumber, truckLicensePlateNumber} = item.locationInventoryActivityGetVO;

      return containerNumber || chassisNumber || trailerNumber || truckLicensePlateNumber || '';
    }

  };

  useEffect(() => {
    const formattedCorrections = rawCorrections?.map((item) => {

      return {
        ...item,
        checkIn: getDates(item).originalCheckIn,
        checkOut: getDates(item).originalCheckOut,
        dateOfSubmission: moment(item?.creationDate).format(DateFormats.DAY),
        containerNumber: item?.containerNumber,
        chassisNumber: item?.chassisNumber,
        trailerNumber: item?.trailerNumber,
        truckLicensePlateNumber: item?.truckLicensePlateNumber,
        orderNumber: item?.locationInventoryActivityGetVO?.orderNumber,
        reason: InventoryCorrectionReasons[item?.reason] ? InventoryCorrectionReasonLabel[item.reason] : 'N/A',
        locationName: item?.locationName,
        status: item?.status,
        driverFirstName: item?.driverFirstName,
        driverLastName: item?.driverLastName,
        driverLicenseNumber: item?.driverLicenseNumber,
        rejectionReason: item?.status === InventoryCorrectionStatus.REJECTED ? item?.rejectionReason : "",
        dateOfSubmissionSort: moment(item?.creationDate),
        orderNumberSort: parseInt(item?.locationInventoryActivityGetVO?.orderNumber),
        equipmentNumber: determineEquipmentNumber(item)
      }
    });
    setFormattedCorrections(formattedCorrections);
    ObservableVariables.PENDING_INVENTORY_CORRECTIONS_COUNT.refreshData(appContext);
  }, [snackbarShowMessage, appContext, rawCorrections, account])

  return <Grid item container>
    <BuyerInventoryFilterContainer item>
        <SubmittedCorrectionsSortFilter
            query={query}
            setQuery={setQuery}
            setSort={setSort}
        />
    </BuyerInventoryFilterContainer>
    {
      loading ?
        <Grid container direction="column">
          <InfoCardLoadingSkeleton/>
        </Grid>
      :
        <InventoryCorrectionsTable
          inventoryCorrections={formattedCorrections}
          handleReviewItem={reviewInventoryCorrection}
          isSupplier={false}
        />
    }
  </Grid>
};

export default SubmittedCorrectionsTab;
